import { ISkill } from "../skills/ISkill";

export const getSkillTitle = (
    { code, officialTitle, shortTitle }: Pick<ISkill, "officialTitle" | "shortTitle" | "code">,
    long?: boolean,
) => `${code}. ${long ? officialTitle : shortTitle}`;
